// extracted by mini-css-extract-plugin
export var dropdownContainer = "_nb-0";
export var leftAlign = "_nb-4";
export var listItem = "_nb-2";
export var listItemWrapper = "_nb-1";
export var operationText = "_nb-3";